import { Injectable, Signal, WritableSignal, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
  public readonly isPending: Signal<boolean>;

  private readonly countSignal: WritableSignal<number> = signal(0);

  constructor() {
    this.isPending = computed((): boolean => this.countSignal() > 0);
  }

  public start(): void {
    this.countSignal.update((count: number): number => count + 1);
  }

  public stop(): void {
    this.countSignal.update((count: number): number => Math.max(0, count - 1));
  }
}
